import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

import { TileDrawerModal } from "@src/components/organisms/modals/tile-drawer-modal/tile-drawer-modal";

export const TileDrawer = () => {
  const showTileDrawerModal = useSelector(
    (state: RootState) => state.yourSlice.modals.tileDrawerModal.showModal,
  );

  return <>{showTileDrawerModal && <TileDrawerModal />}</>;
};
